import { useEffect, useState } from "react";
import styled from "styled-components";
import CustomButton from "../helperComponents/CustomButton";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default function PwaInstallButton() {
  const [installEvent, setInstallEvent] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    function onBeforeInstallPrompt(e) {
      e.preventDefault();
      setInstallEvent(e);
    }

    function onInstalled() {
      setIsInstalled(true);
      setInstallEvent(null);
    }

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        onBeforeInstallPrompt
      );
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (isInstalled || !installEvent) return null;

  return (
    <Wrapper>
      <CustomButton style={{ background: "var(--surface)" }} onClick={onInstall}>
        Installer l'app
      </CustomButton>
    </Wrapper>
  );

  async function onInstall() {
    if (!installEvent) return;
    installEvent.prompt();
    let choice = await installEvent.userChoice;
    if (choice && choice.outcome === "accepted") {
      setInstallEvent(null);
    }
  }
}
